(() => {
  'use strict';
  if (window.NFDCheckoutGuard) return;

  const selector = '.additional-checkout-buttons, [data-shopify="dynamic-checkout-cart"], .shopify-payment-button, [data-shopify="payment-button"], shopify-accelerated-checkout, shopify-accelerated-checkout-cart';
  const checkoutSelector = '[name="checkout"], a[href*="/checkout"], [data-nfd-checkout]';
  const requiresPreparation = (cart) => !cart || !Array.isArray(cart.items)
    || String(cart.note || '').includes('ALTERATIONS:')
    || cart.items.some((item) => (
      String(item.product_type || '').trim().toLowerCase() === 'leather patch' && !item.properties?.['Patch handling']
      || Object.entries(item.properties || {}).some(([key, value]) => value !== null && value !== undefined && value !== '' && (
        /^(Hemming |Patch |\u005fHemming |\u005fPatch |\u005fAlteration )/.test(key)
        || ['_Customization item id', 'Finished inseam', 'Final sale'].includes(key)
      ))
    ));

  const reportFailure = (error) => {
    console.error('Managed alteration checkout could not start', error);
    const message = 'Alteration details could not be confirmed. Please reload the cart and try again.';
    const liveRegion = document.getElementById('error-announcement');
    if (liveRegion) liveRegion.textContent = message;
    document.querySelectorAll('[data-alterations-feedback]').forEach((status) => {
      status.textContent = message;
      status.dataset.state = 'error';
    });
  };

  const guard = {
    selector,
    checkoutSelector,
    requiresPreparation,

    isCheckoutSubmission(form, submitter) {
      if (!(form instanceof HTMLFormElement)) return false;
      if (submitter?.name === 'checkout' || submitter?.matches('[data-nfd-checkout]')) return true;
      const action = new URL(form.action, window.location.href).pathname;
      return /\/checkout\/?$/.test(action) || (!submitter && /\/cart\/?$/.test(action));
    },

    syncCheckoutControls(blocked = this.isBlocked()) {
      document.querySelectorAll(checkoutSelector).forEach((control) => {
        control.toggleAttribute('data-nfd-checkout-guarded', blocked);

        if (!(control instanceof HTMLButtonElement) && !(control instanceof HTMLInputElement)) return;

        if (blocked) {
          if (!control.dataset.nfdOriginalType) {
            control.dataset.nfdOriginalType = control.name === 'checkout' && control.type === 'button'
              ? 'submit'
              : (control.getAttribute('type') || control.type || 'submit');
          }
          control.type = 'button';
        } else if (control.dataset.nfdOriginalType) {
          control.type = control.dataset.nfdOriginalType;
          delete control.dataset.nfdOriginalType;
        }
      });
    },

    setBlocked(blocked) {
      document.documentElement.dataset.nfdAcceleratedCheckout = blocked ? 'blocked' : 'allowed';
      this.syncCheckoutControls(blocked);
    },

    isBlocked() {
      return document.documentElement.dataset.nfdAcceleratedCheckout !== 'allowed';
    },

    async continueManagedCheckout() {
      try {
        let coordinator = window.NFDCartCoordinator;
        if (!coordinator?.continueToCheckout) {
          const loader = window.NFDCartModulesLoader;
          if (!loader?.load) throw new Error('Cart customization loader is unavailable');
          await loader.load();
          coordinator = window.NFDCartCoordinator;
        }
        if (!coordinator?.continueToCheckout) throw new Error('Cart checkout coordinator is unavailable');
        return await coordinator.continueToCheckout();
      } catch (error) {
        reportFailure(error);
        return undefined;
      }
    },

    refresh() {
      this.setBlocked(true);
      const loader = window.NFDCartModulesLoader;
      if (!loader?.load) return;
      loader.load().then(() => {
        window.NFDCartCoordinator?.invalidate('checkout-guard');
      }).catch(reportFailure);
    }
  };

  window.NFDCheckoutGuard = guard;
  guard.syncCheckoutControls();

  document.addEventListener('click', (event) => {
    if (!guard.isBlocked() || !(event.target instanceof Element)) return;

    if (event.target.closest(selector)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (event.target.closest(checkoutSelector)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      guard.continueManagedCheckout();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    if (!guard.isBlocked() || !guard.isCheckoutSubmission(event.target, event.submitter)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    guard.continueManagedCheckout();
  }, true);

  document.addEventListener('cart:change', (event) => {
    if (event.detail?.source !== 'nfd-cart-coordinator') guard.setBlocked(true);
  }, true);
  document.addEventListener('cart:refresh', () => guard.setBlocked(true), true);
  document.addEventListener('nfd:cart-intent', () => guard.setBlocked(true), true);

  new MutationObserver(() => {
    if (guard.isBlocked()) guard.syncCheckoutControls(true);
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) guard.refresh();
  });
  window.addEventListener('focus', () => guard.refresh());

  const channel = typeof BroadcastChannel === 'function' ? new BroadcastChannel('nfd-cart-coordinator-v1') : null;
  channel?.addEventListener('message', () => {
    if (!window.NFDCartCoordinator) guard.refresh();
  });
})();
